import React, { useState, useEffect } from "react";
import DeleteAccountModals from "./DeleteAccountModals";
import {
  FiChevronRight,
  FiShield,
  FiFileText,
  FiInfo,
  FiHelpCircle,
  FiMail,
  FiTrash2,
} from "react-icons/fi";
import { REST_API_URL } from "../../api/config";

const BASE_URL = REST_API_URL;

const getUserTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const buildHeaders = (token, additionalHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...additionalHeaders,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const timezone = getUserTimeZone();
  if (timezone) {
    headers["User-Timezone"] = timezone;
  }

  return headers;
};

export default function PrivacyPolicy() {
  const [links, setLinks] = useState({
    privacy_policy: "",
    about: "",
    help: "",
    contact_us: "",
    terms_of_use: "",
  });
  const [loading, setLoading] = useState(true);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getToken = () => {
    if (typeof window !== "undefined") {
      return (
        localStorage.getItem("accessToken") ||
        sessionStorage.getItem("accessToken")
      );
    }
    return null;
  };

  useEffect(() => {
    const fetchLinks = async () => {
      const token = getToken();

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const headers = buildHeaders(token);

        const response = await fetch(
          `https://api.backend.halper.ai/docs/contact-link/`,
          {
            headers,
          },
        );

        if (!response.ok) throw new Error("Failed to fetch");

        const data = await response.json();
        setLinks(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchLinks();
  }, []);

  const handleFinalDelete = async () => {
    const token = getToken();

    try {
      const headers = buildHeaders(token);

      const response = await fetch(`${BASE_URL}/auth/account-delete/`, {
        method: "DELETE",
        headers,
        body: JSON.stringify({
          email: "gagikvardanyan6666@gmail.com",
          password: "DELETE",
          reason: "Personal reasons",
        }),
      });

      if (response.ok) {
      } else {
        alert("Failed to delete account");
      }
    } catch (err) {
      alert("Error deleting account");
    }
  };

  const MenuItem = ({
    icon,
    text,
    href,
    isDelete = false,
    onClick,
    disabled = false,
  }) => {
    const baseClasses = `
      group flex items-center justify-between p-5 rounded-2xl transition-all duration-300 hover:shadow-lg
      ${
        disabled
          ? "bg-gray-50/50 cursor-not-allowed"
          : isDelete
            ? "bg-red-50/30 hover:bg-red-50/50"
            : "bg-gray-50/30 hover:bg-gray-50/50"
      }
    `;

    const textClasses = `
      font-medium text-lg flex items-center gap-4
      ${
        disabled ? "text-gray-400" : isDelete ? "text-red-700" : "text-gray-900"
      }
    `;

    const iconClasses = `
      w-6 h-6 transition-transform duration-300
      ${
        disabled ? "text-gray-400" : isDelete ? "text-red-500" : "text-gray-500"
      }
    `;

    const Content = () => (
      <>
        <div className="flex items-center gap-4">
          <div
            className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              isDelete ? "bg-red-100" : disabled ? "bg-gray-100" : "bg-gray-100"
            }`}
          >
            {React.cloneElement(icon, { className: iconClasses })}
          </div>
          <div>
            <h3 className={textClasses}>{text}</h3>
            {isDelete && (
              <p className="text-sm text-gray-500 mt-0.5">
                Permanent action • Cannot be undone
              </p>
            )}
          </div>
        </div>

        {!disabled && (
          <div
            className={`transition-transform duration-300 group-hover:translate-x-1 ${
              isDelete ? "text-red-400" : "text-gray-400"
            }`}
          >
            <FiChevronRight className="w-5 h-5" />
          </div>
        )}
      </>
    );

    if (disabled) {
      return (
        <div className={baseClasses}>
          <Content />
        </div>
      );
    }

    if (isDelete) {
      return (
        <button onClick={onClick} className={`${baseClasses} w-full text-left`}>
          <Content />
        </button>
      );
    }

    return (
      <a
        href={href}
        className={`${baseClasses} w-full no-underline`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Content />
      </a>
    );
  };

  if (loading) {
    return (
      <div className="w-full bg-white rounded-2xl p-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded-lg w-48 mb-8"></div>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="mb-4">
              <div className="flex items-center gap-4 p-5">
                <div className="w-12 h-12 bg-gray-200 rounded-xl"></div>
                <div className="flex-1">
                  <div className="h-6 bg-gray-200 rounded w-32 mb-2"></div>
                  <div className="h-4 bg-gray-100 rounded w-24"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      {showDeleteModal && (
        <DeleteAccountModals
          onDeleteFinal={handleFinalDelete}
          closeModal={() => setShowDeleteModal(false)}
        />
      )}

      <div className="w-full bg-white rounded-2xl p-6 shadow-sm">
        <div className="mb-8">
          <h2 className="font-normal text-2xl text-gray-900 mb-2">
            Legal & Support
          </h2>
          <p className="text-gray-500 text-sm">
            Important documents and support resources
          </p>
        </div>

        <div className="space-y-4 mb-8">
          <MenuItem
            icon={<FiShield />}
            text="Privacy & Policy"
            href={links.privacy_policy}
          />

          <MenuItem
            icon={<FiFileText />}
            text="Terms of Use"
            href={links.terms_of_use}
          />

          <MenuItem icon={<FiInfo />} text="About" href={links.about} />

          <MenuItem
            icon={<FiHelpCircle />}
            text="Help / FAQ"
            href={links.help}
          />

          <MenuItem
            icon={<FiMail />}
            text="Contact us"
            href={links.contact_us}
          />
        </div>

        <div className="pt-6 border-t border-gray-100">
          <div className="mb-4">
            <h3 className="font-semibold text-gray-500 text-sm uppercase tracking-wider mb-2">
              Account Actions
            </h3>
          </div>

          <MenuItem
            icon={<FiTrash2 />}
            text="Delete Account"
            isDelete={true}
            onClick={() => {
              setShowDeleteModal(true);
            }}
          />
        </div>
      </div>
    </>
  );
}
